import { z } from "zod";

export const formSchema = z.object({
  name: z
    .string()
    .min(2, "Ingresa un nombre")
    .max(100, "Máximo 100 caracteres"),
  email: z.string().email("Ingresa un correo válido"),
});
